import script from "./WeChatConvWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./WeChatConvWindow.vue?vue&type=script&lang=ts&setup=true"

import "./WeChatConvWindow.vue?vue&type=style&index=0&id=7d74f2c0&lang=css"

const __exports__ = script;

export default __exports__